import { IServiceState } from './state';
import { IServiceAction } from './action';
import { validateInput, validateLength } from 'commons/ZimssaHelper';

export const defaultState: IServiceState = {
  serviceName: '',
  serviceImage: '',
  partnerServiceImages: [],
  introduce: '',
  startYear: '',
  businessRegistrationNumber: '',
  businessRegistrationImage: '',
  businessRegistrationOwner: '',
  taxClassification: '',
  familyRelationImage: '',
  location1: '',
  location2: '',
  serviceValid: false,
};

export interface IServiceReducer {
  (state: IServiceState, action: IServiceAction): IServiceState;
}

export default function serviceReducer(
  state: IServiceState,
  action: IServiceAction
): IServiceState {
  const { type, value } = action;
  const SET_LOCATION_1 = 'location1';
  switch (type) {
    case 'SET_STATE':
      if (typeof value === 'object' && !Array.isArray(value)) {
        state = value || state;
      } else {
        state = defaultState;
      }
      break;
    // location1 값이 변경되면 location1에 의존적인 location2 값도 초기화
    case SET_LOCATION_1:
      state = { ...state, location1: value as string, location2: '' };
      break;
    case 'INIT_STATE':
      state = defaultState;
      break;
    default:
      state = { ...state, [type]: value };
      break;
  }

  state = {
    ...state,
    serviceValid:
      validateInput(state.startYear) &&
      validateInput(state.businessRegistrationNumber.trim()) &&
      validateLength(state.businessRegistrationNumber, 10) &&
      validateInput(state.businessRegistrationImage.trim()) &&
      validateInput(state.businessRegistrationOwner.trim()) &&
      validateInput(state.taxClassification.trim()) &&
      validateInput(state.location1.trim()) &&
      validateInput(state.location2.trim()),
  };
  if (
    state.businessRegistrationOwner === '가족' &&
    state.familyRelationImage === ''
  ) {
    state = { ...state, serviceValid: false };
  }
  return state;
}
